/* Squalo US slide cart drawer controller. Global: window.SQCartDrawer.
   Renders body + upsell via the Section Rendering API (cart-context, server-formatted money).
   Mutations: /cart/change.js (qty/remove), /cart/add.js (upsell). No EUR formatting in JS. */
window.SQCartDrawer = (function () {
  var drawer, overlay, body, upsell, countEl, total, urgency, checkout, continueBtn, closeBtn;
  var inited = false, busy = false, count = 0, timer = null, lastFocus = null;

  function $(id){ return document.getElementById(id); }
  function cache(){
    drawer=$('sxCartDrawer'); overlay=$('sxCartOverlay'); body=$('sxCartBody');
    upsell=$('sxCartUpsell'); countEl=$('sxCartCount'); total=$('sxCartTotal'); urgency=$('sxCartUrgency');
    checkout=$('sxCartCheckout'); continueBtn=$('sxCartContinue'); closeBtn=$('sxCartClose');
  }
  function frag(html){ var d=document.createElement('div'); d.innerHTML=html; return d; }

  /* ---------- open / close ---------- */
  function open(){
    if(!drawer)return;
    lastFocus=document.activeElement;
    drawer.classList.add('open'); drawer.setAttribute('aria-hidden','false');
    if(overlay)overlay.classList.add('open');
    document.body.style.overflow='hidden';
    maybeUrgency();
    setTimeout(function(){ if(closeBtn)closeBtn.focus(); },60);
  }
  function close(){
    if(!drawer)return;
    drawer.classList.remove('open'); drawer.setAttribute('aria-hidden','true');
    if(overlay)overlay.classList.remove('open');
    document.body.style.overflow='';
    stopUrgency();
    if(lastFocus&&lastFocus.focus)lastFocus.focus();
  }
  function openAndRefresh(){ open(); refresh(); }

  /* ---------- render via Section Rendering API ---------- */
  /* Cart-context sections endpoint (reliable, never the cacheable / index route).
     One retry so a transient failure never strands a stale drawer. */
  /* NB: must NOT send Accept: application/json here. With that header /cart returns the
     cart object and ignores ?sections=; the default Accept yields the sections map. */
  function fetchSections(signal){
    var url='/cart?sections=sq-us-cart-drawer-items,sq-us-cart-upsell&_='+Date.now();
    return fetch(url,{signal:signal})
      .then(function(r){ if(!r.ok)throw 0; return r.json(); })
      .catch(function(){ return fetch(url,{signal:signal}).then(function(r){ return r.json(); }); });
  }
  /* Render body + upsell from a {sectionId: html} map (from /cart?sections= or change.js .sections). */
  function renderFromSections(sections){
    if(!sections)return;
    var bodyHtml=sections['sq-us-cart-drawer-items'];
    if(bodyHtml!=null && body){
      var inner=frag(bodyHtml).querySelector('.sxcd__body-inner');
      if(inner){ body.innerHTML=''; body.appendChild(inner); syncSummary(); bindBody(); }
    }
    var upHtml=sections['sq-us-cart-upsell'];
    if(upHtml!=null && upsell){
      var rail=frag(upHtml).querySelector('.sxcd__upsell-rail');
      upsell.innerHTML='';
      if(rail){ upsell.appendChild(rail); upsell.hidden=false; bindUpsell(); } else { upsell.hidden=true; }
    }
  }
  function syncSummary(){
    var s=body?body.querySelector('.sxcd__summary'):null;
    /* estimated total (subtotal + shipping, server-formatted string — no JS money formatting)
       onto the checkout button; item count into the drawer header */
    if(total)total.textContent = (s && s.getAttribute('data-est-str')) ? '· '+s.getAttribute('data-est-str') : '';
    if(countEl){
      var n=s?(parseInt(s.getAttribute('data-count'),10)||0):0;
      countEl.textContent = n>0 ? '('+n+')' : '';
    }
  }
  function readCount(){
    var s=body?body.querySelector('.sxcd__summary'):null;
    count = s ? (parseInt(s.getAttribute('data-count'),10)||0) : 0;
    return count;
  }
  function refreshBadge(signal){
    return fetch('/cart.js',{headers:{'Accept':'application/json'},signal:signal})
      .then(function(r){if(!r.ok)throw new Error('badge'); return r.json();})
      .then(function(c){
        if(typeof c.item_count!=='number')throw new Error('badge');
        document.querySelectorAll('#sxCartBadge').forEach(function(b){
          b.textContent=c.item_count; b.style.display=c.item_count>0?'':'none';
        });
        return true;
      }).catch(function(){return false;});
  }
  function refresh(options){
    setBusy(true);
    var controller = new AbortController();
    var timeout = options && options.timeout ? setTimeout(function(){ controller.abort(); },options.timeout) : null;
    return fetchSections(controller.signal)
      .then(function(data){
        if(controller.signal.aborted || !data || typeof data['sq-us-cart-drawer-items']!=='string' || typeof data['sq-us-cart-upsell']!=='string' || !frag(data['sq-us-cart-drawer-items']).querySelector('.sxcd__body-inner'))throw new Error('sections');
        renderFromSections(data); return refreshBadge(controller.signal);
      })
      .then(function(ok){ readCount(); updateFoot(); return ok; })
      .catch(function(){ return false; /* report failed totals refresh to promo feedback */ })
      .then(function(ok){ if(timeout)clearTimeout(timeout); setBusy(false); return ok; });
  }

  function setBusy(b){ busy=b; if(drawer)drawer.classList.toggle('is-busy',b); }
  function updateFoot(){
    var empty = readCount()<=0;
    if(drawer)drawer.classList.toggle('is-empty',empty);
    if(checkout){ checkout.classList.toggle('is-disabled',empty); checkout.disabled=empty; }
    if(empty)stopUrgency(); else maybeUrgency();
  }
  function maybeUrgency(){
    if(!window.SQ_URGENCY_ON||!urgency||!drawer)return;
    if(!drawer.classList.contains('open'))return;
    if(readCount()<=0){ stopUrgency(); urgency.hidden=true; return; }
    if(!timer)startUrgency();
  }

  /* ---------- qty / remove (qty 0 = remove) ----------
     Change by line-item KEY (identity), never by line index: a drawer that has
     drifted out of sync with the cart must still remove the item the user clicked.
     The mutation asks change.js to return the re-rendered sections so the redraw is
     atomic with the change and in true cart context. Any failure re-syncs from truth. */
  function change(key,qty){
    if(busy||!key)return;
    setBusy(true);
    fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},
      body:JSON.stringify({id:key,quantity:qty,sections:'sq-us-cart-drawer-items,sq-us-cart-upsell',sections_url:'/'})})
      .then(function(r){ return r.json().then(function(d){ return {ok:r.ok,d:d}; }); })
      .then(function(res){
        if(res.ok && res.d && res.d.sections){
          renderFromSections(res.d.sections);
          return refreshBadge().then(function(){ readCount(); updateFoot(); setBusy(false); });
        }
        return refresh(); /* change rejected or no sections -> resync, never strand a stale drawer */
      })
      .catch(function(){ return refresh(); });
  }
  function bindBody(){
    if(!body)return;
    body.querySelectorAll('.sxcd__row').forEach(function(row){
      var key=row.getAttribute('data-key'); if(!key)return;
      var box=row.querySelector('.sxcd__qty');
      if(box){
        var span=box.querySelector('span');
        var cur=parseInt(span?span.textContent:'1',10)||1;
        var dec=box.querySelector('[data-act=dec]'), inc=box.querySelector('[data-act=inc]');
        if(dec)dec.addEventListener('click',function(){ change(key,Math.max(0,cur-1)); });
        if(inc)inc.addEventListener('click',function(){ change(key,cur+1); });
      }
      var rm=row.querySelector('.sxcd__remove');
      if(rm)rm.addEventListener('click',function(){ change(key,0); });
    });
    body.querySelectorAll('[data-sxcd-close]').forEach(function(a){ a.addEventListener('click',close); });
  }

  /* ---------- upsell add ---------- */
  function addVariant(id,btn){
    if(busy||!id)return;
    setBusy(true);
    if(btn)btn.classList.add('is-loading');
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},
      body:JSON.stringify({items:[{id:+id,quantity:1}]})})
      .then(function(r){ if(!r.ok)throw new Error('add'); return r.json(); })
      .then(function(){ return refresh(); })
      .catch(function(){ setBusy(false); if(btn)btn.classList.remove('is-loading'); });
  }
  function bindUpsell(){
    if(!upsell)return;
    upsell.querySelectorAll('.sxcd__add').forEach(function(b){
      if(b.tagName==='A')return; /* "Choose size" link goes to PDP */
      if(b.hasAttribute('data-reveal')){
        /* reveal this card's size row only (sizes are hidden until tapped) */
        b.addEventListener('click',function(){
          var sizes=b.parentNode.querySelector('.sxcd__sizes');
          if(sizes)sizes.hidden=false;
          b.hidden=true;
        });
      } else {
        b.addEventListener('click',function(){ addVariant(b.dataset.variantId,b); });
      }
    });
    upsell.querySelectorAll('.sxcd__size').forEach(function(b){
      b.addEventListener('click',function(){ if(b.hasAttribute('disabled'))return; addVariant(b.dataset.variantId,b); });
    });
    upsell.querySelectorAll('[data-sxcd-close]').forEach(function(a){ a.addEventListener('click',close); });
  }

  /* ---------- urgency (restrained, opt-in) ---------- */
  function startUrgency(){
    if(!urgency||!window.SQ_URGENCY_ON)return;
    if(readCount()<=0){ urgency.hidden=true; return; }
    stopUrgency();
    var mins=window.SQ_URGENCY_MIN||10, end=Date.now()+mins*60000, pre=window.SQ_URGENCY_PRE||'Reserved for';
    urgency.hidden=false;
    function tick(){
      var s=Math.max(0,Math.round((end-Date.now())/1000));
      var m=Math.floor(s/60), ss=s%60;
      urgency.textContent = pre+' '+m+':'+(ss<10?'0':'')+ss;
      if(s<=0)stopUrgency();
    }
    tick(); timer=setInterval(tick,1000);
  }
  function stopUrgency(){ if(timer){ clearInterval(timer); timer=null; } }

  /* ---------- init ---------- */
  function init(){
    if(inited)return; cache(); if(!drawer)return; inited=true;
    if(closeBtn)closeBtn.addEventListener('click',close);
    if(overlay)overlay.addEventListener('click',close);
    if(continueBtn)continueBtn.addEventListener('click',close);
    document.addEventListener('keydown',function(e){ if(e.key==='Escape'&&drawer.classList.contains('open'))close(); });
    document.querySelectorAll('#sxCartTrigger').forEach(function(t){
      t.addEventListener('click',function(e){ e.preventDefault(); openAndRefresh(); });
    });
    /* wire the server-rendered first paint */
    syncSummary(); bindBody();
    if(upsell&&upsell.querySelector('.sxcd__upsell-rail'))bindUpsell(); else if(upsell)upsell.hidden=true;
    updateFoot();
  }
  if(document.readyState!=='loading')init();
  else document.addEventListener('DOMContentLoaded',init);

  return { open:open, close:close, openAndRefresh:openAndRefresh, refresh:refresh };
})();
